export function useNotificationBanner(message: AdvancedNotification | string, type: NotificationType, timeout = 0) {
  const store = useNotificationBannerStore();
  store.setNotificationBanner(message, type, timeout);

  return {
    close: () => store.clearNotificationBanner(),
  };
}
